const CommissionProgressBar = ({ paid, total }) => {
    // Handle edge case where total is 0 or undefined
    if (!total) return <span className="text-slate-400 text-xs">N/A</span>;

    // Calculate percentage
    const percentagePaid = Math.round((paid / total) * 100);

    // Clamp the BAR WIDTH to 0-100. The label keeps the true percentage.
    // The lower bound matters since 2026-08-19: upline/team discounts can push a
    // DOC/TOC line negative, and a negative width is ignored by CSS, which renders
    // an empty track that reads as "nothing paid" rather than "owes money".
    const widthPercentage = Math.max(0, Math.min(percentagePaid, 100));

    // Determine color based on status
    let colorClass;
    if (percentagePaid > 100) {
        colorClass = 'bg-danger';
    }
    else if (percentagePaid === 100) {
        colorClass = 'bg-success';
    }

    return (
        // Added min-w-[100px] to prevent crushing in table
        <div className="flex flex-col w-full max-w-[140px] min-w-[100px] gap-1.5">
            {/* <div className="flex justify-between items-center text-[11px] leading-none w-full">
                <span className="text-slate-500 mr-2">Paid</span>
                <span className="text-slate-700 font-bold">
                    {percentagePaid}%
                </span>
            </div> */}

            {/* Increased height and used gray-200 for better visibility of track */}
            {/* <div
                className="w-full bg-gray-200 rounded-full h-2.5 overflow-hidden border border-gray-100"
                title={`${percentagePaid}% Paid`}
            >
                <div
                    className={`h-full rounded-full ${colorClass}`}
                    style={{ width: `${widthPercentage}%` }}
                ></div>
            </div> */}
            <div className="progress" style={{ position: 'relative' }}>
                <div className={`progress-bar progress-bar-striped progress-bar-animated ${colorClass || ''}`}
                    role="progressbar"
                    aria-valuenow={percentagePaid}
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style={{ width: `${widthPercentage}%` }}>
                </div>
                {/* Percentage label overlaid on the full track so it stays visible
                    even at 0% (a zero-width fill bar would otherwise clip the text). */}
                <span style={{
                    position: 'absolute',
                    inset: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '11px',
                    fontWeight: 600,
                    lineHeight: 1,
                    color: percentagePaid >= 50 ? '#ffffff' : '#334155',
                    pointerEvents: 'none',
                }}>
                    {percentagePaid}%
                </span>
            </div>
        </div>
    );
};
export default CommissionProgressBar;
